import * as React from "react";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@mui/icons-material/Clear";
import Button from "@mui/material/Button";
import styles from "./SearchBox.module.css";

export default function SearchBox(props) {
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("Enter key was pressed");
      // Perform any action you want when Enter is pressed
      if (props.handleHitEnter) {
        props.handleHitEnter(event);
      }
    }
  };

  return (
    <div className={styles.SearchBox}>
      <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
        <div className={styles.SearchBoxContainer}>
          <OutlinedInput
            id="outlined-adornment-password"
            placeholder={props.placeholder}
            value={props.searchText}
            type="text"
            onChange={props.handleSearchText}
            onKeyDown={handleKeyPress}
          />
          <Button
            className={styles.SearchButton}
            variant="text"
            onClick={props.onClick}
          >
            {" "}
            <SearchIcon />
          </Button>
        </div>
      </FormControl>
    </div>
  );
}
